import {Component, Input} from '@angular/core';
import {InfluencerCampaign} from '../../../../models/influencer-campaign';
import {NumberUtils} from '../../../utils/number.utils';
import {Router, ActivatedRoute} from '@angular/router';
import {CommonConstant, listOrderedPlatforms} from '../../../app.constants';
import {UserService} from '../../../services/user.service';
import {CacheService} from '../../../services/cache/cache.service';

@Component({
  selector: 'campaign-influencers-item',
  templateUrl: './campaign-influencers-item.component.html',
  styleUrls: ['./campaign-influencers-item.component.scss']
})
export class CampaignInfluencersItemComponent {

  @Input()
  influencer: InfluencerCampaign;
  @Input()
  isCampaignDetails: boolean;
  @Input()
  campaignId: number;
  @Input()
  isLastItem: boolean;

  public orderedPlatformList = [];

  private companyId: any;

  constructor(private userService: UserService,
              private cacheService: CacheService,
              private router: Router,
              private route: ActivatedRoute) {
    this.orderedPlatformList = listOrderedPlatforms;
    this.companyId = this.userService.getCompanyId();
  }

  hasPlatform(platformName, influencer) {
    const activePlatform = Object.getOwnPropertyDescriptor(influencer, 'campaign_influencer_platform' + platformName);
    return activePlatform ? activePlatform.value : false;
  }

  private normalizeNumberData(value: number): string {
    if (!value) {
      return '0';
    }
    return NumberUtils.normalizeNumberToString(value);
  }

  get activeAccount() {
    return this.userService.getCompanyId();
  }

  getCountryCode(influencer) {
    return influencer && influencer.country.code ? influencer.country.code : CommonConstant.INTERNATION_COUNTRY_CODE;
  }

  get campaignInfluencerPost() {
    if (!this.influencer || !this.influencer.campaign_influencer_number_of_post) {
      return '0';
    }
    return this.normalizeNumberData(this.influencer.campaign_influencer_number_of_post);
  }

  get campaignInfluencerReach() {
    if (!this.influencer || !this.influencer.campaign_influencer_reach) {
      return '0';
    }
    return this.normalizeNumberData(this.influencer.campaign_influencer_reach.value);
  }

  get campaignInfluencerEngagement() {
    if (!this.influencer || !this.influencer.campaign_influencer_engagement) {
      return '0';
    }
    return this.normalizeNumberData(this.influencer.campaign_influencer_engagement.value);
  }

  get campaignInfluencerImpact() {
    if (!this.influencer || !this.influencer.campaign_influencer_engagement || !this.influencer.campaign_influencer_reach) {
      return '0';
    }
    const engagement = this.influencer.campaign_influencer_engagement.value;
    const reach = this.influencer.campaign_influencer_reach.value;
    if (!reach || reach === 0 || !engagement || engagement === 0) {
      return '0';
    }
    const impact = (engagement * 100 / reach).toFixed(0);
    return impact;
  }

  openInfluencerCampaign(influencerId, campaignInfluencerId, campaignId) {
    const backUrl = window.location.hash.substring(1, window.location.hash.indexOf('?'));
    if (influencerId && campaignInfluencerId && campaignId) {
      this.cacheService.disableCacheRemoving();
      return this.router.navigate(['influencer', influencerId, 'campaign'], {
        queryParams: {
          campaignInfluencerId: campaignInfluencerId,
          from_path: backUrl,
          selectedCampaign: campaignId,
          activeAccount: this.activeAccount
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/campaigns/campaign-influencers-item/campaign-influencers-item.component.ts